<template>
  <div>
    <div class="page-box">
      <div class="tr">
        <el-button type="primary" @click="openDialog(null)" v-pms="'add'">添加资讯分类</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableDataLoading"
        border
        style="width: 100%">
        <el-table-column
          fixed
          type="index"
          label="序号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="classCode"
          label="分类编码">
        </el-table-column>
        <el-table-column
          prop="name"
          label="分类名称">
        </el-table-column>
        <el-table-column
          prop="seqNum"
          label="排序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button @click="openDialog(`${scope.$index}`)" type="text" size="small" v-pms="'edit'">编辑</el-button>
            <el-button @click="deleteNewsClass(scope.$index)" type="text" size="small" v-pms="'delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.pageNum"
      :page-sizes="[10, 15, 20]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total">
    </el-pagination>
    <el-dialog
      :title="editMsg"
      :visible.sync="dialogFormVisible"
      v-if="dialogFormVisible"
      :modal="false"
      :v-loading="submitting">
      <div class="add-form">
        <el-form
          ref="form"
          :model="dialogData"
          label-width="94px"
          :rules="rules">
          <el-form-item
            prop="classCode"
            label="分类编码"
          >
            <el-input type="text" v-model="dialogData.classCode" placeholder="请填写分类编码"></el-input>
          </el-form-item>
          <el-form-item
            prop="name"
            label="分类名称"
          >
            <el-input type="text" v-model="dialogData.name" placeholder="请填写分类名称"></el-input>
          </el-form-item>
          <el-form-item
            prop="seqNum"
            label="排序号"
          >
            <el-input type="number" v-model="dialogData.seqNum" placeholder="请填写排序号"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input class="el-input"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入备注"
                      v-model="dialogData.remark">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" style="width: 100px;">关 闭</el-button>
        <el-button type="primary" @click="submitNewsClass" style="width: 100px;">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {news} from '../../api'
import {validImage, toolbarOptions, quillUploadSuccess} from '@/utils'
import {getSession} from '../../utils/session'
import {ORG_CODE, USER_ID} from '../../constants'
export default {
  name: 'NewsClass',
  data () {
    return {
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      tableDataLoading: false,
      submitting: false,
      editMsg: '',
      dialogFormVisible: false,
      dialogData: {
        newsClassId: '',
        classCode: '',
        name: '',
        seqNum: '',
        createUser: '',
        updateUser: '',
        orgCode: '',
        remark: ''
      },
      rules: {
        classCode: [
          {required: true, message: '请输入分类编码', trigger: 'blur'},
          {max: 10, message: '长度不能超过32个字符', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入分类名称', trigger: 'blur'},
          {max: 10, message: '长度不能超过32个字符', trigger: 'blur'}
        ],
        remark: [
          {message: '请输入备注', trigger: 'blur'},
          {max: 255, message: '长度不能超过255个字符', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await news.pageNewsClass({
        param: {
          orgCode: getSession(ORG_CODE)
        },
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    },
    openDialog (index) {
      if (index == null) {
        this.editMsg = '添加资讯分类'
        this.dialogData = {}
      } else {
        this.editMsg = '编辑资讯分类'
        this.dialogData = this.tableData[index]
      }
      this.dialogFormVisible = true
    },
    submitNewsClass () { // 添加编辑
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.dialogData.newsClassId) {
            this.addNewsClass()
          } else {
            this.editNewsClass()
          }
        } else {
          return false
        }
      })
    },
    async addNewsClass () { // 添加方法
      this.dialogData.createUser = getSession(USER_ID)
      this.dialogData.orgCode = getSession(ORG_CODE)
      this.submitting = true
      let {code, msg} = await news.addNewsClass(this.dialogData)
      this.submitting = false
      this.dialogFormVisible = false
      this.getTableData()
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '资讯分类添加成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: msg || '资讯分类添加失败'
        })
      }
    },
    async editNewsClass () { // 编辑方法
      this.dialogData.updateUser = getSession(USER_ID)
      this.submitting = true
      let {code, msg} = await news.updateNewsClass(this.dialogData)
      this.submitting = false
      this.dialogFormVisible = false
      this.getTableData()
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '资讯分类修改成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: msg || '资讯分类修改失败'
        })
      }
    },
    deleteNewsClass (index) {
      let newsClassId = this.tableData[index].newsClassId
      let name = this.tableData[index].name
      this.$confirm(`确定要删除资讯分类【${name}】吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await news.delNewsClass({
          newsClassId: newsClassId
        })
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '资讯分类删除成功'
          })
          this.tableData.splice(index, 1)
        } else {
          this.$message({
            type: 'error',
            message: msg || '资讯分类删除失败'
          })
        }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
  .el-form {
    width: 100%;
    max-width: 700px;
  }
</style>
